import { useEffect, useRef, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import useOutsideClick from "../../../hooks/useOutsideClick";

export type FindCheckListProps = {
    id: number;
    label: string;
    children: CheckboxData;
    history?: string | undefined;
    enabledButton: boolean;
    onChange: (searchField: string[]) => void;
};

export type CheckboxItem = {
    label: string;
    value: string;
};

export type CheckboxData = {
    [group: string]: CheckboxItem[];
};

const FindCascadingCheckList = (props: FindCheckListProps) => {
    const divRef = useRef<HTMLDivElement>(null);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [searchResults, setSearchResults] = useState(props.children);
    const [SelectedLabel, setSelectedLabel] = useState<Array<string>>([]);
    const [selected, setSelected] = useState<Array<string>>([]);

    useEffect(() => {
        setSearchResults(props.children);
    }, [props.children]);

    useEffect(() => {
        if (props.history !== undefined && props.history !== null) {
            const historyStr = String(props.history); // Ensures '0' is a string

            const newSelected = historyStr.includes(";") ? historyStr.split(";") : [historyStr];

            setSelected(newSelected);
            setSelectedLabel(getLabelsFromValues(newSelected));
        }
    }, [props.history]);

    const getLabelsFromValues = (values: string[]): string[] => {
        const labels: string[] = [];
        Object.values(props.children).forEach((group: CheckboxItem[]) => {
            group.forEach((item: CheckboxItem) => {
                if (values.includes(item.value)) {
                    labels.push(item.label);
                }
            });
        });

        return labels;
    };
    useEffect(() => {
        props.onChange?.(selected);
    }, [selected]);

    const toggleItem = (item: CheckboxItem) => {
        setSelected(prev => {
            const updated = prev.includes(item.value)
                ? prev.filter(value => value !== item.value)
                : [...prev, item.value];
            return updated;
        });

        setSelectedLabel(prev => {
            const updated = prev.includes(item.label)
                ? prev.filter(label => label !== item.label)
                : [...prev, item.label];
            return updated;
        });
    };

    const toggleGroup = (group: string) => {
        const groupItems = props.children[group];
        const allSelected = groupItems.every(item => selected.includes(item.value));

        const updatedSelected = allSelected
            ? selected.filter(value => !groupItems.some(item => item.value === value))
            : [...selected, ...groupItems.filter(item => !selected.includes(item.value)).map(item => item.value)];

        setSelected(updatedSelected);
        setSelectedLabel(getLabelsFromValues(updatedSelected));
    };
    const onOutsideClick = () => {
        setDropdownOpen(false);
    };
    useOutsideClick(divRef, onOutsideClick);
    return (
        <div
            className={"CheckBoxList-dropdown" + (dropdownOpen ? "-selected" : "")}
            key={props.id}
            style={{ width: "100%" }}
            ref={divRef}
        >
            <button
                tabIndex={0}
                onClick={() => setDropdownOpen(o => !o)}
                disabled={!props.enabledButton}
                className={"" + (props.enabledButton ? "CheckBoxList-buttonEnabled" : "")}
                style={{ textAlign: "left" }}
                title={SelectedLabel.length > 0 ? SelectedLabel.join(", ") : SelectedLabel[0]}
            >
                <span
                    style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "inline-block",
                        flexGrow: 1,
                        width: "300px",
                    }}
                >
                    {SelectedLabel.length > 0 ? SelectedLabel.join(", ") : SelectedLabel[0]}
                </span>

                <BsChevronDown style={{ fontSize: "10px", float: "right", flexShrink: 0, marginTop: "5px" }} />
            </button>

            {dropdownOpen && (
                <div
                    style={{
                        position: "absolute",
                        zIndex: 1000,
                        backgroundColor: "white",
                        height: "300px",
                        width: "312px",
                        overflowY: "auto",
                        border: "1px solid #ccc",
                        padding: "5px",
                        marginLeft: "0px",
                    }}
                >
                    {Object.entries(props.children).map(([group, items]) => {
                        const allSelected = items.every(item => selected.includes(item.value));
                        return (
                            <div
                                key={group}
                                className="checklist-group"
                                style={{ marginBottom: "1rem" }}
                            >
                                <label>
                                    <input
                                        type="checkbox"
                                        checked={allSelected}
                                        onChange={() => toggleGroup(group)}
                                        className="FindCheckbox"
                                    />
                                    <span className="checklist-group-label-text">{group}</span>
                                </label>
                                <div
                                    style={{ marginLeft: "1rem" }}
                                    className="checklist-items"
                                >
                                    {items.map(label => (
                                        <label
                                            key={label.value}
                                            style={{ display: "block" }}
                                            className="checklist-item"
                                        >
                                            <input
                                                type="checkbox"
                                                checked={selected.includes(label.value)}
                                                onChange={() => toggleItem(label)}
                                                className="FindCheckbox"
                                            />
                                            <span className="checklist-label-text">{label.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default FindCascadingCheckList;
